import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosLiberacionValorInstalacionEnumChoice, gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, gridSizeMdLg8, hasPermission, IvaENUM, useCheckPermissionsArray, useLoaders, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useUpdatePreventa } from "@/shared/actions/erp";
import { useFetchGetSolicitudLiberacionValorInstalacion, useFetchPutSolicitudLiberacionValorInstalacion } from "@/shared/actions/erp/supervisor-liberacion-valor-instalacion";
import { CustomNumberTextField, CustomTextArea, CustomTextField, CustomTextFieldNoForm, GeneralTable, SingleButton } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useTableColumnsLiberacionValorInstalacion } from "@/shared/hooks/useTableColumnsLiberacionValorInstalacion";
import { AlertSeverityEnum, IDataSoliLibeValorInstalacion } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Typography } from "@mui/material";
import { MRT_RowData } from "material-react-table";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from 'yup';

export const newLiberacionValorInstalacion = yup.object({
  motivo: yup.string().required('Campo Obligatorio'),
  id_solicitud_no_cobro_instalacion: yup.string().required('Campo Obligatorio'),
  id_preventa: yup.string().required('Campo Obligatorio'),
  valor_instalacion: yup.string().required('Campo Obligatorio'),
  valor_descuento: yup.number().required('Campo Obligatorio'),

})

type ISupervicionVentaFrom = {
  motivo: string;
  id_solicitud_no_cobro_instalacion: string;
  id_preventa: string;
  valor_instalacion: string;
  valor_descuento: number;
  identificacion?: string;
  razon_social?: string;

  ///* buro crediticio
  puntaje_score?: string;
  puntaje_score_empresa?: string;
  puntaje_score_sobreendeudamiento?: string;
};

interface TableLiberacionValorInstalacionComponenteProps {
  accion: boolean;
  estado_solicitud: EstadosLiberacionValorInstalacionEnumChoice
}


const TableLiberacionValorInstalacionComponente = ({ accion, estado_solicitud }: TableLiberacionValorInstalacionComponenteProps) => {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudnocobroinstalacion,
    PermissionsEnum.api_change_solicitudnocobroinstalacion,
  ]);

  ///* store
  const setAlert = useUiStore(s => s.setAlert);

  ///* hook
  const {
    globalFilter,
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnBase } = useTableColumnsLiberacionValorInstalacion({
    estado_solicitud: estado_solicitud
  });

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const [open, setOpen] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0)

  ///* form
  const form = useForm<ISupervicionVentaFrom>({
    resolver: yupResolver(newLiberacionValorInstalacion)
  });
  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = form;


  ///* fetch
  const { isLoading, data: supervicionRes,
    isRefetching, } = useFetchGetSolicitudLiberacionValorInstalacion(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        numero_referencia: globalFilter,
        estado_solicitud: estado_solicitud,
        ...filterObject,
        filterByState: false
      }
    );

  const {
    mutateAsync: fetchPutSolicitudLiberacionValorInstalacion,
    isPending: isPendingSolLibreacion,
  } = useFetchPutSolicitudLiberacionValorInstalacion();
  const {
    mutateAsync: mutateAsyncPutPreventa,
    isPending: isPendingPreventa
  } = useUpdatePreventa({ enableAlert: false });

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  ///* funciones

  const onEdit = (e: MRT_RowData) => {

     if (!hasPermission(PermissionsEnum.liberacion_valor_instalacion)) {
      return setAlert(
        true,
        "Acceso denegado. No cumples con los permisos necesarios: [403]",
        AlertSeverityEnum.error
      );
    }

    const info = e as IDataSoliLibeValorInstalacion;
    setOpen(true);
    setTotal(0);
    reset({
      id_preventa: info.preventa_data.id_preventa,
      id_solicitud_no_cobro_instalacion: info.id_solicitud_no_cobro_instalacion,
      valor_instalacion: info.preventa_data.valor_instalacion,
      valor_descuento: +info.preventa_data.valor_instalacion,
      identificacion: info.prospecto_data.identificacion,
      razon_social: info.prospecto_data.razon_social,
      puntaje_score: info.prospecto_data.puntaje_score,
      puntaje_score_empresa: info.prospecto_data.puntaje_score_empresa,
      puntaje_score_sobreendeudamiento: info.prospecto_data.puntaje_score_sobreendeudamiento
    });
  }

  useLoaders(
    isPendingSolLibreacion ||
    isPendingPreventa
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataSoliLibeValorInstalacion>
            columns={columnBase}
            data={supervicionRes?.data.data || []}
            isLoading={isLoading || isPendingSolLibreacion}
            isRefetching={isRefetching}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={supervicionRes?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            positionActionsColumn='first'
            onEdit={onEdit}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            //ocultar acciones
            enableColumnActions={accion}
            enableEditing={accion}

          />
        </Grid>
      </Grid>
      <ScrollableDialogProps
        onCloseIcon={() => {
          reset({})
          setOpen(false)
        }}
        open={open}
        //dialogContentText="Deseas aprobar la solicitud para la eliminiación del costo de instalación. ¿Estás seguro?"
        title="Reducción del valor de instalación."
        minWidth="60%"
        dividers={true}
        contentNode={

          <Grid container spacing={3}>

            <Grid item container {...gridSizeMdLg4} spacing={3}>
              <CustomTextFieldNoForm
                disabled={true}
                label={`Puntaje Score`}
                defaultValue={form.getValues().puntaje_score}
                size={gridSizeMdLg12}
              />
              <CustomTextFieldNoForm
                disabled={true}
                label={`Puntaje Score Empresa`}
                defaultValue={form.getValues().puntaje_score_empresa}
                size={gridSizeMdLg12}
              />
              <CustomTextFieldNoForm
                disabled={true}
                label={`Puntaje Score Sobreendeudamiento`}
                defaultValue={form.getValues().puntaje_score_sobreendeudamiento}
                size={gridSizeMdLg12}
              />
            </Grid>

            <Grid item container {...gridSizeMdLg8} spacing={3}>
              <CustomTextField
                size={gridSizeMdLg12}
                label="Identificacion"
                disabled={true}
                name="identificacion"
                control={form.control}
                defaultValue={form.getValues().identificacion ?? ''}
                error={errors.identificacion}
                helperText={errors.identificacion?.message}
                required={true}
              />

              <CustomTextField
                size={gridSizeMdLg12}
                label="Nombre"
                disabled={true}
                name="razon_social"
                control={form.control}
                defaultValue={form.getValues().razon_social ?? ''}
                error={errors.razon_social}
                helperText={errors.razon_social?.message}
                required={true}
              />

              <CustomTextField
                size={gridSizeMdLg6}
                label="Valor de Instalación"
                disabled={true}
                name="valor_instalacion"
                control={form.control}
                defaultValue={form.getValues().valor_instalacion ?? ''}
                error={errors.valor_instalacion}
                helperText={errors.valor_instalacion?.message}
                required={true}
              />

              <CustomNumberTextField
                control={form.control}
                name={"valor_descuento"}
                min={0}
                step={0.01}
                max={+form.getValues().valor_instalacion}
                defaultValue={form.getValues().valor_descuento || ''}
                size={gridSizeMdLg6}
                label={`Valor Descuento`}
                error={errors.valor_descuento}
                isPositive={true}
                helperText={errors.valor_descuento?.message}
                onChangeValue={(e) => {
                  const aux = +form.getValues().valor_instalacion;
                  if (e > aux) {
                    form.setValue('valor_descuento', aux);
                    setAlert(true, 'El valor descuento no puede ser mayor al valor de instalación.', AlertSeverityEnum.warning)
                    setTotal(0);
                    return;
                  }
                  const valor = +form.getValues().valor_instalacion - e
                  setTotal(valor);

                }}
              />
            </Grid>





            <CustomTextArea
              label="Ingresar Motivo"
              name="motivo"
              maxRows={3}
              control={form.control}
              defaultValue={form.getValues().motivo ?? ''}
              error={errors.motivo}
              helperText={errors.motivo?.message}
              required={true}
            />

            <Grid item {...gridSizeMdLg12}>
              <Typography variant="inherit" textAlign={'end'}
                sx={{ color: '#6C737F' }}>
                {`Total a pagar: $${total.toFixed(2)}`}
              </Typography>
            </Grid>

            <Grid item {...gridSizeMdLg12}>
              <Grid container justifyContent={'space-between'}>

                <Grid item>
                  <SingleButton
                    color={"primary"}
                    variant="text"
                    label="Rechazar"
                    onClick={() => {

                      setConfirmDialogIsOpen(true);
                      setConfirmDialog({
                        isOpen: true,
                        title: '¡Confirmar!',
                        subtitle:
                          'Estás a punto de rechazar este cambio no se podrá deshacer. ¿Te gustaría continuar?',
                        onClose() {
                          setConfirmDialogIsOpen(false);
                        },
                        onConfirm: async () => {

                          setOpen(false);
                          setConfirmDialogIsOpen(false);

                          try {

                            if (!form.getValues().motivo) return setAlert(true, 'Ingresar motivo', AlertSeverityEnum.error);

                            const resp = await fetchPutSolicitudLiberacionValorInstalacion({
                              id: form.getValues().id_solicitud_no_cobro_instalacion!,
                              params: {
                                motivo: form.getValues().motivo,
                                estado_solicitud: EstadosLiberacionValorInstalacionEnumChoice.RECHAZADO
                              },
                            });

                            if (resp.code === 200) {
                              await mutateAsyncPutPreventa({
                                id: form.getValues().id_preventa, data: {
                                  no_cobrar: false
                                }
                              });
                            }

                            //window.location.reload();
                            //setConfirmDialogIsOpen(false);

                          } catch (error) {

                          } finally {

                          }

                        },
                        btnTitle: 'Cerrar',
                      });

                    }
                    }
                  />
                </Grid>
                <Grid item>
                  <SingleButton
                    color={'primary'}
                    variant="contained"
                    label="Aceptar"

                    onClick={
                      handleSubmit(async (dataForm) => {
                        console.log(dataForm);

                        const resp = await fetchPutSolicitudLiberacionValorInstalacion({
                          id: dataForm.id_solicitud_no_cobro_instalacion,
                          params: {
                            motivo: dataForm.motivo,
                            estado_solicitud: EstadosLiberacionValorInstalacionEnumChoice.APROBADO
                          },
                        });

                        if (resp.code === 200) {
                          await mutateAsyncPutPreventa({
                            id: dataForm.id_preventa, data: {
                              no_cobrar: false,
                              generar_pdf_contrato: true,
                              valor_instalacion: total.toFixed(2),
                              valor_instalacion_total: ((total * IvaENUM.IVA) + total).toFixed(2),
                              valor_instalacion_iva: ((total * IvaENUM.IVA) + total).toFixed(2)
                            }
                          });
                        }

                        setOpen(false);
                        reset({})

                      }, (e) => {
                        console.log(e);

                      })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />
    </>

  );
}


export default TableLiberacionValorInstalacionComponente;
